import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//授权
import { silentLogin, isLogin } from '../api/pay'
Vue.use(VueRouter)
/**
 * 
 * hidden  //是否需要隐藏标题栏 true 隐藏 
 * hiddenBack  //是否需要隐藏返回按钮 true 隐藏 
 */
const routes = [
  {
    path: '/',
    name: 'i',
    redirect: "/pay"
  },

  /**
   * 单独的一个页
   */
  // 订单列表
  {
    path: '/payList',
    name: 'payList',
    component: () => import('../views/payList.vue'),
    meta: {
      title: '付款列表'
    }
  },

  //优惠卷
  {
    path: '/couponslist',
    // name: 'payList',
    component: () => import('../views/coupons_list.vue'),
    meta: {
      title: '代金券兑换'
    }
  },

  // 订单列表
  {
    path: '/pay',
    name: 'pay',
    component: () => import('../views/pay.vue'),
    meta: {
      title: '付款'
    }
  },


  //支付完成
  {
    path: '/completion_payment',
    name: 'completion_payment',
    component: () => import('../views/completion_payment.vue'),
    meta: {
      title: '支付完成'
    }
  },

]


const router = new VueRouter({
  mode: 'history',
  routes
})

// router.beforeEach((to, from, next) => {
//   // var s = to.path.substr(1)
//   // if(/^-?\d+$/.test(s)){
//   //   next({
//   //     replace:true,
//   //     path:"/ticketInfo",
//   //     query:{
//   //       order_sn:s
//   //     }
//   //   })
//   // }else{
//   // }
//   next()
// })


//授权
router.afterEach((to, from) => {
})
export default router
var _times = 0
router.beforeEach((to, from, next) => {
  if (is_wechat()) {
    var code = getUrlKey('code')
    if (code) {
      if (_times++ == 0) {
        silentLogin({ code: code }).then((res) => {
          if (res.resultCode == 1){
            localStorage.setItem("access-token", res.resultInfo.access_token)
          }
          next()
        })
      } else {
        next()
      }
    } else {
      if (_times++ == 0) {
        /***
           * 
           * 
           * 1.先判断是否有access_token 如果没有access_token 则肯定没有登录
           * 2.在判断该access_token是否有效 
           * 
           * 
           * 
           */
        isLogin({ url: window.location.href }).then((res) => {
          if (res.resultCode == 1) {
            if (res.resultInfo.isLogin == 0) {
              window.location.href = res.resultInfo.redirectUrl.headers.location[0]
            } else {
              next()
            }
          }else{
              next()
          }
        })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})




//授权
function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}


//首先判断是不是微信环境
function is_wechat() {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {

    //更改
    return false
  }
}
